import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import LoadingScreen from './LoadingScreen'

interface RequirePlatformAdminProps {
  children: ReactNode
}

export default function RequirePlatformAdmin({ children }: RequirePlatformAdminProps) {
  const { isPlatformAdmin, loading } = useAuth()
  if (loading) return <LoadingScreen />
  if (!isPlatformAdmin) return <Navigate to="/dashboard" replace />
  return <>{children}</>
}
